<template>
    <b-tooltip class="cx_tooltip" custom-class :target="target" :placement="placement" :delay=" { show: 300, hide: 100 }" boundary="window" @hide="onHide" @show="onShow"><span v-html="$translate(title)"/></b-tooltip>
</template>

<script lang="ts">
import { Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Tooltip extends Vue {
  @Prop({default:''}) public title: string;
  @Prop({default:null}) public target: HTMLElement;
  @Prop({default:'right'}) public placement: string;

  hover :boolean = false;
  onShow(ev :any){
    var el = ev.relatedTarget  as HTMLElement;
    el.addEventListener('mouseenter', this.onHover);
    el.addEventListener('mouseleave', this.onHoverOut);    
    //tooltipエレメントがbody直下に作成され、独立したスタッキングコンテクストになるのでzIndexを適切にセットする必要がある
    el.style.zIndex = String.format('{0}',this.$api.getMaxZIndex() + 210); //グローバルメニューが200のため、オフセット100=>210に変更
  }
  
  onHide(ev :any){

    if (this.hover) {
      ev.preventDefault();
      return;
    }
    var el = ev.relatedTarget  as HTMLElement;
    el.removeEventListener('mouseenter', this.onHover);
    el.removeEventListener('mouseleave', this.onHoverOut);    
  }
  onHover(){
    this.hover = true;
  }
  onHoverOut() {
    if(this.hover){
      this.$root.$emit('bv::hide::tooltip');
    }
    this.hover = false;
  }
}
</script>
<style lang="scss">

.tooltip {
  opacity: 1 !important;
  // z-index: 2070 !important; //popupEditorより上に表示
  
  /* 配置が変わると矢印部分の追加・調整が必要です */
  --background-color: #f8f0d3;//吹き出しの背景色
  --shadow-color:  rgba(85, 85, 85, 0.575); //影の色

  .tooltip-inner{
      text-align: left !important;  
      font-size: 13px;
      max-width: 350px !important;
      padding:10px !important;

    /* 影をつける */    
      box-shadow: 1px 1px 5px var(--shadow-color);    
      color:#2C304F  !important;
      background-color:var(--background-color)   !important;
  }
    /* ボーダーによる三角形描画だと影を付けられないので、四角形を45度回転させる */      
  .arrow::before {    
    border:none !important;
    box-shadow: 1px 1px 5px  var(--shadow-color);            
    background-color: var(--background-color) ;    
    width: 10px;
    height: 10px;
    transform: rotate(45deg); /* POINT 要素を変形 */
  }
    
  /* top */
  &[x-placement^="top"] {
    .tooltip-inner {
      margin-bottom: 5px; //オフセット        
    }
    .arrow {
      margin-bottom: 5px; //オフセット  
      width: 1rem;
      clip:rect(auto 1rem 0.4rem auto);
    }    
    .arrow::before {        
      top:-8px;
    }
  }

  /* bottom */
  &[x-placement^="bottom"] {
    .tooltip-inner {
      margin-top: 5px; //オフセット        
    }
    .arrow {
      margin-top: 5px; //オフセット        
      width: 1rem;
      clip:rect(auto 1rem 0.4rem auto);
    }    
    .arrow::before {       
      bottom: -8px ;
    }
  }

  /* right */
  &[x-placement^="right"] {
    .tooltip-inner {
      margin-left: 5px; //オフセット
    }
    .arrow {
      margin-left: 5px; //オフセット
      height: 1rem;
      clip:rect(auto 0.4rem 1rem auto);
    }
    .arrow::before {     
      right: -8px ;
    }    
  }

  /* right */
  &[x-placement^="left"] {
    .tooltip-inner {
      margin-right: 5px; //オフセット    
    }
    .arrow {
      margin-right: 5px; //オフセット    
      height: 1rem;
      clip:rect(auto 0.4rem 1rem auto);
    }
    .arrow::before {     
      left: -8px ;
    }    
  }
}

</style>